'use client';

import {
    Box,
    Typography,
    Grid,
    Chip,
    Stack,
} from "@mui/material";

import { useTranslations } from "next-intl";

const AirxpressLite = () => {
    const t = useTranslations("ServicePage.airxpress_lite");

    return (
        <Box sx={{ px: 2, py: { xs: 8, md: 6 }, backgroundColor: "#f8fafc" }}>
            <Box sx={{ maxWidth: "lg", margin: "auto", textAlign: "center", mb: 8 }}>
                <span className="inline-block bg-[#F15859] text-white text-xs font-bold px-6 py-1.5 rounded-full mb-6 shadow-sm">
                    {t('chip')}
                </span>
                <Typography variant="h4" component="h2" sx={{ fontWeight: 800, color: "#132c4b", mb: 2 }}>
                    {t('title')}
                </Typography>
                <Typography variant="body1" sx={{ color: "#64748b" }}>
                    {t('description')}
                    <br />
                    {t('description_2')}
                </Typography>
            </Box>
            <Grid container spacing={4} sx={{ maxWidth: "lg", margin: "auto" }}>
                {/* Left Column: Airbnb Plan */}
                <Grid size={{ xs: 12, md: 6 }}>
                    <Box sx={{
                        backgroundColor: "white",
                        borderRadius: "24px",
                        border: "1px solid #e2e8f0",
                        p: 4,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column"
                    }}>
                        <Box sx={{ textAlign: "center", mb: 4 }}>
                            <Chip label={t('single_chip')} size="small" sx={{ mb: 2, backgroundColor: "#e2e8f0", fontWeight: "bold" }} />
                            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1e293b", mb: 1 }}>
                                {t('single_title')}
                            </Typography>
                            <Typography variant="caption" sx={{ color: "#94a3b8" }}>
                                {t('single_caption')}
                            </Typography>
                        </Box>

                        {/* Card 1: Fixed Price */}
                        <Box sx={{
                            backgroundColor: "#132c4b",
                            borderRadius: "16px",
                            p: 3,
                            color: "white",
                            mb: 3
                        }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="caption" sx={{ fontWeight: "bold" }}>{t('fixed_plan_label')}</Typography>
                                <Chip label={t('recommended_chip')} size="small" sx={{ backgroundColor: "#F15859", color: "white", fontSize: "0.7rem", height: "20px" }} />
                            </Box>
                            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                                {t('fixed_price')}
                            </Typography>

                            <Typography variant="caption" sx={{ opacity: 0.8, display: 'block', mb: 3 }}>
                                {t('fixed_note')}
                            </Typography>
                        </Box>

                        {/* Card 2: Revenue Share */}
                        <Box sx={{
                            border: "1px solid #e2e8f0",
                            borderRadius: "16px",
                            p: 3,
                            mb: 3
                        }}>
                            <Typography variant="caption" sx={{ color: "#132c4b", fontWeight: "bold", mb: 1, display: 'block' }}>{t('revenue_plan_label')}</Typography>
                            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1e293b", mb: 2 }}>
                                {t('revenue_price')}
                            </Typography>
                        </Box>

                        {/* Note */}
                        <Box sx={{ backgroundColor: "#fff7ed", p: 3, borderRadius: "12px" }}>
                            <Stack direction="row" spacing={1} alignItems="flex-start">
                                <Typography variant="caption" sx={{ color: "#c2410c", fontWeight: "bold", minWidth: "30px" }}>{t('note_label')}</Typography>
                                <Box>
                                    <Typography variant="caption" sx={{ color: "#9a3412", display: "block", mb: 1 }}>
                                        {t('note_1')}
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: "#9a3412", display: "block" }}>
                                        {t('note_2')}
                                    </Typography>
                                </Box>
                            </Stack>
                        </Box>
                    </Box>
                </Grid>

                {/* Right Column: Multi-channel Plan */}
                <Grid size={{ xs: 12, md: 6 }}>
                    <Box sx={{
                        backgroundColor: "white",
                        borderRadius: "24px",
                        border: "1px solid #e2e8f0",
                        p: 4,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column"
                    }}>
                        <Box sx={{ textAlign: "center", mb: 4 }}>
                            <Chip label={t('multi_chip')} size="small" color="error" variant="outlined" sx={{ mb: 2, fontWeight: "bold", borderColor: "#cbd5e1", color: "#64748b" }} />
                            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1e293b", mb: 1 }}>
                                {t('multi_title')}
                            </Typography>
                            <Typography variant="caption" sx={{ color: "#64748b" }}>
                                {t('multi_caption')}
                            </Typography>

                        </Box>

                        {/* Card 1: Volume Discount */}
                        <Box sx={{
                            backgroundColor: "#132c4b",
                            borderRadius: "16px",
                            p: 3,
                            color: "white",
                            mb: 3
                        }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="caption" sx={{ fontWeight: "bold" }}>{t('multi_fixed_label')}</Typography>
                                <Chip label={t('multi_basic_chip')} size="small" sx={{ backgroundColor: "#F15859", color: "white", fontSize: "0.7rem", height: "20px" }} />
                            </Box>
                            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                                {t('multi_fixed_price')}
                            </Typography>
                            <Typography variant="caption" sx={{ opacity: 0.8, display: 'block', mb: 3 }}>
                                {t('multi_fixed_note')}
                            </Typography>

                            <Box sx={{ mb: 3 }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", py: 1, borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
                                    <Typography variant="caption">{t('rooms_1_9')}</Typography>
                                    <Typography variant="caption" fontWeight="bold">{t('price_1_9')}</Typography>
                                </Box>
                                <Box sx={{ display: "flex", justifyContent: "space-between", py: 1, borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
                                    <Typography variant="caption">{t('rooms_10_49')}</Typography>
                                    <Typography variant="caption" fontWeight="bold">{t('price_10_49')}</Typography>
                                </Box>
                                <Box sx={{ display: "flex", justifyContent: "space-between", py: 1, borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
                                    <Typography variant="caption">{t('rooms_50_99')}</Typography>
                                    <Typography variant="caption" fontWeight="bold">{t('price_50_99')}</Typography>
                                </Box>
                                <Box sx={{ display: "flex", justifyContent: "space-between", py: 1 }}>
                                    <Typography variant="caption">{t('rooms_100_plus')}</Typography>
                                    <Typography variant="caption" fontWeight="bold">{t('price_100_plus')}</Typography>
                                </Box>
                            </Box>
                        </Box>

                        {/* Card 2: Hybrid */}
                        <Box sx={{
                            border: "1px solid #e2e8f0",
                            borderRadius: "16px",
                            p: 3,
                            mb: 3,
                            backgroundColor: "#f8fafc"
                        }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Typography variant="caption" sx={{ fontWeight: "bold", color: "#1e293b" }}>{t('hybrid_label')}</Typography>
                                <Chip label={t('popular_chip')} size="small" sx={{ backgroundColor: "#e2e8f0", color: "#475569", fontSize: "0.7rem", height: "20px", fontWeight: "bold" }} />
                            </Box>
                            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1e293b", mb: 1 }}>
                                {t('hybrid_price')}
                            </Typography>
                            <Typography variant="caption" sx={{ color: "#64748b", display: 'block' }}>
                                {t('hybrid_desc')}
                            </Typography>
                        </Box>

                        {/* Card 3: Revenue Share */}
                        <Box sx={{
                            border: "1px solid #e2e8f0",
                            borderRadius: "16px",
                            p: 3,
                            backgroundColor: "#f8fafc"
                        }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Typography variant="caption" sx={{ fontWeight: "bold", color: "#1e293b" }}>{t('multi_revenue_label')}</Typography>
                                <Chip label={t('flexible_chip')} size="small" sx={{ backgroundColor: "#e2e8f0", color: "#475569", fontSize: "0.7rem", height: "20px", fontWeight: "bold" }} />
                            </Box>
                            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1e293b", mb: 1 }}>
                                {t('multi_revenue_price')}
                            </Typography>
                            <Typography variant="caption" sx={{ color: "#64748b", display: 'block' }}>
                                {t('multi_revenue_desc')}
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AirxpressLite;